export const FAST_FEATURES_EXCLUDED_SUBTYPES = ['BUS', '38N']
export const MAX_COMPARISON_ITEMS = 5
export const MIN_COMPARISON_ITEMS = 2
export const isValidComparisonRange = (value, min) =>
  value >= (min ?? MIN_COMPARISON_ITEMS) && value <= MAX_COMPARISON_ITEMS
export const VEHICLES = 'vehicles'
export const DATE_FORMAT = 'DD MMM YYYY'
export const VEHICLE_TYPE_M2 = 'CHEC2'
export const VEHICLE_TYPE_CHEC_PLUS = 'CHECP'
export const VEHICLE_COMPARE_TOOLTIP = 'vehicle-compare-tooltip'
export const SCHEMA = 'schema'
export const FEATURES = 'features'
export const MODULE_TYPE = 'moduleType'
export const XMC3 = 'XMC3'
export const XMC4 = 'XMC4'
export const XMC5 = 'XMC5'
export const XMC6 = 'XMC6'
export const INPUT_PIN_SCHEMA = 'feature.contains.input-pin'
export const OUPUT_PIN_SCHEMA = 'feature.contains.output-pin'
export const ADD_REMOVE_FEATURES = 'ADD_REMOVE_FEATURES'
export const ADD_REMOVE_FEATURE_COLLECTIONS = 'ADD_REMOVE_FEATURE_COLLECTIONS'
export const APPLY_FAST_FEATURES = 'APPLY_FAST_FEATURES'
export const FEATURE = 'features'
export const FAST_FEATURES = 'fastFeatures'
export const FEATURE_COLLECTIONS = 'featureCollections'
export const NOTFOUND = 'NOTFOUND'
export const UNSUPPORTED = 'UNSUPPORTED'
export const DB_CODE_35M_011 = '35M-011'
export const DB_CODE_35M_012 = '35M-012'
export const DB_CODE_35M_015 = '35M-015'
export const X_SERIES = 'X-Series'
